module.exports = __webpack_public_path__ + "static/media/edit.e052e910.svg";